import { Page, Text, View, Document, StyleSheet, Font, Image } from "@react-pdf/renderer";
import persianFont from "../../../../assets/fonts/YekanBakh/woff/YekanBakh-Regular.woff";
import { convertToJalali } from "../../../../utils/date";
import { numberWithCommas } from "../../../../utils/utility";

import logoImage from "../../../../assets/imgs/green logo.png";

const AccommodationPdf = ({ orderItem }) => {
    Font.register({
        family: "iranSans",
        src: persianFont,
    });
    const styles = StyleSheet.create({
        page: {
            direction: "rtl",
            rowGap: 10,
            padding: "8px 20px",
            fontFamily: "iranSans",
        },
        displayRow: {
            flexDirection: "row-reverse",
            alignItems: "center",
            columnGap: 2,
        },
        spaceBetween: {
            justifyContent: "space-between",
        },
        columnGap: {
            columnGap: 10,
        },
        displayColumn: {
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-end",
        },
        section: {
            rowGap: 5,
        },
        logoImage: {
            width: 100,
            height: 20,
        },
        logoText: {
            color: "#006363",
            fontSize: 5,
            fontWeight: 700,
        },
        text: {
            fontSize: 8,
        },
        boldText: {
            fontSize: 8,
            fontWeight: 700,
        },
        title: {
            flexDirection: "row-reverse",
            padding: "2px 8px",
            backgroundColor: "#E6EBF0",
        },
        information: {
            flexDirection: "row-reverse",
            alignItems: "center",
            columnGap: 2,
            padding: "2px 8px",
            backgroundColor: "#F7F7F7",
            fontSize: 8,
        },
        arrowIcon: {
            width: 5,
            height: 5,
        },
        label: {
            padding: "1px 6px",
            border: "1px solid #808080",
            borderRadius: "10px",
        },
        price: {
            padding: "2px 8px",
            borderBottom: "1px solid #F0F0F0",
        },
        line: {
            width: "5px",
            height: "20px",
            margin: "0 2px 0 5px",
            borderLeft: "1px solid #F0F0F0",
        },
    });
    const image = `https://api.atripa.ir${orderItem?.accommodation?.image?.image}`;

    return (
        <Document>
            <Page key={Math.random()} size="A4" style={styles.page}>
                <View style={[styles.displayRow, styles.spaceBetween]}>
                    <div style={styles.displayColumn}>
                        <Image src={logoImage} style={styles.logoImage} />
                    </div>
                    <Text style={styles.boldText}>ووچر هتل</Text>
                    <div>
                        <div style={[styles.displayRow, styles.spaceBetween]}>
                            <Text style={styles.text}>پشتیبانی:</Text>
                            <Text style={styles.boldText}>{`${"0915 401 76 61"}`}</Text>
                        </div>
                        <div style={[styles.displayRow, styles.spaceBetween]}>
                            <Text style={styles.text}> شماره پیگیری:</Text>
                            <Text style={styles.boldText}>{`${orderItem?.tracking_code}`}</Text>
                        </div>
                        <div style={[styles.displayRow, styles.spaceBetween]}>
                            <Text style={styles.text}> تاریخ صدور بلیط:</Text>
                            <Text style={styles.boldText}>{`${convertToJalali(orderItem?.create_date)}`}</Text>
                        </div>
                    </div>
                </View>

                <View style={styles.section}>
                    <div style={styles.title}>
                        <Text style={styles.boldText}>جزئیات هتل</Text>
                    </div>

                    <div style={[styles.information, styles.spaceBetween]}>
                        <div style={styles.displayRow}>
                            {/* <Image src={image} /> */}
                            {/* <Image source={`https://api.atripa.ir${orderItem?.accommodation?.image?.image}`} /> */}
                            <div style={styles.displayColumn}>
                                <div style={[styles.displayRow, styles.columnGap]}>
                                    <Text style={styles.boldText}>
                                        {orderItem.accommodation.accommodation.name || orderItem.accommodation.accommodation.english_name} هتل{" "}
                                    </Text>
                                    <Text style={styles.label}>ستاره {orderItem.accommodation.accommodation.star}</Text>
                                </div>
                                <Text style={styles.boldText}>
                                    {orderItem.accommodation.accommodation.address || orderItem.accommodation.accommodation.english_address}
                                </Text>
                            </div>
                        </div>

                        <div style={[styles.displayRow, styles.spaceBetween]}>
                            <div>
                                <div style={[styles.displayRow, styles.spaceBetween]}>
                                    <Text style={styles.boldText}>ساعت تحویل:</Text>
                                    <Text style={styles.boldText}>12:00</Text>
                                </div>
                                <div style={[styles.displayRow, styles.spaceBetween]}>
                                    <Text style={styles.boldText}>تاریخ ورود:</Text>
                                    <Text style={styles.boldText}>{convertToJalali(orderItem.accommodation.check_in)}</Text>
                                </div>
                            </div>
                            <div style={styles.line}>
                                <Text style={styles.boldText}></Text>
                            </div>
                            <div>
                                <div style={[styles.displayRow, styles.spaceBetween]}>
                                    <Text style={styles.boldText}>ساعت تخلیه:</Text>
                                    <Text style={styles.boldText}>12:00</Text>
                                </div>
                                <div style={[styles.displayRow, styles.spaceBetween]}>
                                    <Text style={styles.boldText}>تاریخ خروج:</Text>
                                    <Text style={styles.boldText}>{convertToJalali(orderItem.accommodation.check_out)}</Text>
                                </div>
                            </div>
                        </div>
                    </div>
                </View>

                <View style={styles.section}>
                    {orderItem.accommodation.rooms.map(room => {
                        return (
                            <div>
                                <div style={[styles.displayRow, styles.spaceBetween]}>
                                    <Text style={styles.boldText}> {room.name}</Text>
                                    {room.type && <Text style={[styles.boldText, styles.label]}> {room.type}</Text>}
                                </div>
                                {room.passengers.map(passenger => {
                                    return (
                                        <div style={[styles.displayRow, styles.spaceBetween, styles.information]}>
                                            <Text style={styles.boldText}>
                                                {passenger.first_name}
                                                {passenger.last_name}
                                            </Text>
                                            <Text style={styles.boldText}>جنسیت:{passenger.gender === 1 ? "مرد" : "زن"} </Text>
                                            <Text style={styles.boldText}>{passenger.national_id || passenger.passport_number} کدملی / پاسپورت:</Text>
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    })}
                </View>

                <View style={styles.section}>
                    <div style={styles.title}>
                        <Text style={styles.boldText}>جزئیات قیمت</Text>
                    </div>
                    <div style={[styles.displayRow, styles.spaceBetween, styles.price]}>
                        <Text style={styles.boldText}>قیمت کل:</Text>
                        <Text style={styles.boldText}>ریال {numberWithCommas(orderItem.accommodation?.total_price)}</Text>
                    </div>
                </View>
            </Page>
        </Document>
    );
};

export default AccommodationPdf;
